import { useMemo } from 'react';

import { collection, query, orderBy, Query } from 'firebase/firestore';

import { useCollectionData } from 'react-firebase-hooks/firestore';

import { useAuth } from '../contextProviders/AuthProvider';
import { useData } from '../contextProviders/DataProvider';
import { firestore } from '../firebase';
import { OrgVanityUrlRequest } from '../types/Page';

export default function useOrgVanityUrlRequests() {
  const { isGod } = useAuth();
  const { userState } = useData();

  const requestsQuery = useMemo(() => {
    if (!isGod) return null;
    if (userState.status !== 'ready' || !userState.userProfile) return null;

    return query(
      collection(firestore, 'orgVanityUrlRequest'),
      orderBy('createTime', 'desc')
    ) as Query<OrgVanityUrlRequest>;
  }, [isGod, userState.userProfile, userState.status]);

  const [requests, isLoading, error] = useCollectionData<OrgVanityUrlRequest>(requestsQuery);

  if (userState.status === 'logged_out') {
    return {
      requests: null,
      isLoading: false,
      error: new Error('User must be logged in'),
    };
  }

  return {
    requests: requests || null,
    isLoading:
      isLoading ||
      userState.status === 'authenticating_user' ||
      userState.status === 'authenticating_profile' ||
      userState.status === 'authenticating_memberships',
    error,
  };
}
